import React from 'react';
import { renderIcon, DefaultCampaignIcon } from '../../SprintDetail/FlowchartView/utils/renderIcon';
import AtlasFolderName from '../../DocsArea/Atlas/components/AtlasFolderName';
import '../../DocsArea/Atlas/components/AtlasFolderNode.css';

const CampaignsAtlasNode = ({
  node,
  live,
  expanded,
  selected,
  dragging,
  registerNode,
  onPointerDown,
  onClick,
  onContextMenu,
  renaming,
  onRenameCommit,
  onRenameCancel,
  onOpen,
  onOpenInNewTab,
}) => {
  const childCount = node.childCount || node.docCount || 0;
  return (
    <div
      ref={registerNode(node.id)}
      data-atlas-no-pan
      data-atlas-folder-id={node.id}
      className={[
        'atlas__node',
        expanded ? 'atlas__node--expanded' : '',
        selected ? 'atlas__node--selected' : '',
        dragging ? 'atlas__node--dragging' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        width: node.width,
        transform: `translate(${(live || node).x}px, ${(live || node).y}px)`,
      }}
      onPointerDown={(e) => onPointerDown?.(e, node.id)}
      onClick={(e) => onClick(e, node.id)}
      onDoubleClick={(e) => {
        e.stopPropagation();
        onOpen?.(node.id);
      }}
      onMouseDown={(e) => {
        if (e.button !== 1) return;
        e.preventDefault();
        e.stopPropagation();
        onOpenInNewTab?.(node.id);
      }}
      onContextMenu={(e) => onContextMenu(e, node.id)}
    >
      <span className="atlas__node-icon" data-atlas-icon aria-hidden>
        {renderIcon(node.icon, {
          size: '36px',
          fallback: <DefaultCampaignIcon size={36} />,
          defaultColor: 'currentColor',
        })}
      </span>
      <span className="atlas__node-text">
        <AtlasFolderName
          folderId={node.id}
          name={node.name}
          onRename={onRenameCommit}
          isEditingTitle={renaming}
          onFinishEdit={onRenameCancel}
          placeholderName="Untitled"
          editHint="Type a campaign name..."
        />
        <span className={`atlas__node-meta${childCount === 0 ? ' atlas__node-meta--empty' : ''}`}>
          <span className="atlas__node-meta-n">{childCount}</span>
          nested
        </span>
      </span>
    </div>
  );
};

export default CampaignsAtlasNode;
